<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Điều xe
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: 'name',
    headerName: $t('labels.abstemious')
  },
  {
    field: 'totalJourney',
    headerName: $t('labels.journeyCompletedCount'),
    valueGetter: (params: any) => {
      const { totalJourney } = params.data
      return $formatters.formatNumber(totalJourney || 0)
    }
  },
  {
    field: 'totalJourneyScheduleAuto',
    headerName: $t('labels.journeyAutoCount'),
    valueGetter: (params: any) => {
      const { totalJourneyScheduleAuto } = params.data
      return $formatters.formatNumber(totalJourneyScheduleAuto || 0)
    }
  },
  {
    field: 'totalJourneyScheduleManual',
    headerName: $t('labels.journeyHandmadeCount'),
    valueGetter: (params: any) => {
      const { totalJourneyScheduleManual } = params.data
      return $formatters.formatNumber(totalJourneyScheduleManual || 0)
    }
  },
  {
    field: 'totalJourneyHasDelayTime',
    headerName: $t('labels.journeyDelayCount'),
    valueGetter: (params: any) => {
      const { totalJourneyHasDelayTime } = params.data
      return `${$formatters.formatNumber(totalJourneyHasDelayTime || 0)}`
    }
  },
  {
    field: 'totalTrip',
    headerName: $t('labels.tripCompletedCount'),
    valueGetter: (params: any) => {
      const { totalTrip } = params.data
      return `${$formatters.formatNumber(totalTrip || 0)}`
    }
  },
  {
    field: 'totalOrder',
    headerName: $t('labels.orderCompletedCount'),
    valueGetter: (params: any) => {
      const { totalOrder } = params.data
      return `${$formatters.formatNumber(totalOrder || 0)}`
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getDistribution, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
